import type { Editor } from 'slate';

import { isAlineInlineElement } from '../internal';

export function withInlines<T extends Editor>(editor: T): T {
  const { isInline } = editor;
  editor.isInline = element => isAlineInlineElement(element) || isInline(element);
  return editor;
}
